import styled from "styled-components";
import { useSnapshot } from "valtio";
import { state } from "../../../context/store";
import { Button, Text, Row, Column } from '../../Blocks';
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
import { getOrdinal, closePopups } from "../../../utilities";
import { ColorSwatchContainer } from '../index.js'

const ModalMultiRib = () => {
    const snap = useSnapshot(state.current);

    const initialReset = () => {
        state.current.status.confirmResetRibs = true
    };

    const resetRibs = () => {

        const ribs = state.current.choices.ribs.selected.rib;

        ribs.forEach((_, i) => {
            ribs[i] = { name: "white", hex: "#ddd", src: null };
        });

        state.current.status.confirmResetRibs = false;
    };

    const MultiRibWidget = () => {
        const incrementRib = () => {
            if (snap.status.currentRib < snap.initialChoices.ribLimit) {
                state.current.status.currentRib = snap.status.currentRib + 1;
            }
        };

        const decrementRib = () => {
            if (snap.status.currentRib > 1) {
                state.current.status.currentRib = snap.status.currentRib - 1;
            }
        };

        return (
            <Column>
                <Row>
                    <IconWrap
                        onClick={() => decrementRib()}
                        $disabled={snap.status.currentRib <= 1}
                    >
                        <AiOutlineArrowLeft />
                        <p>Prev Rib</p>
                    </IconWrap>

                    <Text size="14px">
                        Select {snap.status.currentRib}
                        {getOrdinal(snap.status.currentRib)} Rib:<br />
                        {snap.choices.ribs.selected.rib[snap.status.currentRib - 1].name}
                    </Text>
                    <IconWrap
                        onClick={() => incrementRib()}
                        $disabled={
                            snap.status.currentRib >= snap.initialChoices.ribLimit
                        }
                    >
                        <AiOutlineArrowRight />
                        <p>Next Rib</p>
                    </IconWrap>
                </Row>

                <Row justify="center" gap="20px" flex="wrap" pad="10px" id="rib-config-options" >
                    <ColorSwatchContainer colors={snap.colors} section="ribs" />
                </Row>

            </Column>
        );
    };



    return (


        <Column>
            <MultiRibWidget />
            <Row justify="center" gap="40px">
                <Button accent={snap.status.confirmResetRibs === true} handleClick={snap.status.confirmResetRibs === true ? resetRibs : initialReset}
                >
                    {snap.status.confirmResetRibs ? "Confirm Reset" : "Reset All Ribs"}

                </Button>
                <Button handleClick={(e) => closePopups(e)}>
                    {snap.choices.ribs.settings.currentRib < 7
                        ? "Go back"
                        : "Finished"}
                </Button>
            </Row>
        </Column>



    );
};

export default ModalMultiRib;


const IconWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 66px;
  
  @media (width > 800px) {
      justify-content: center !important;
      align-items: center !important;
      width: unset;
}

  & svg {
    fill: #222;
    width: 30px;
    height: 30px;
    transition: 0.2s all;
    fill: ${(props) => (props.$disabled ? "#eee" : "#222")};
    pointer-events: ${(props) => (props.$disabled ? "none" : "auto")};
    cursor: ${(props) => (props.$disabled ? "none" : "pointer")};
    
    @media (prefers-color-scheme: dark) {
        fill: ${(props) => (props.$disabled ? "#333" : "#fff")};
    }
    @media (width > 800px) {
        width: 40px;
        height: 40px;
    }

  }

  & svg:hover {
    fill: #aaa;
  }

  & p {
    color: ${(props) => (props.$disabled ? "#eee" : "#222")};
    margin-block: 0;
    padding-block: 0;

    @media (prefers-color-scheme: dark) {
      color: ${(props) => (props.$disabled ? "#333" : "#fff")};
    }
  }
`;
